import React from 'react';
import { Button } from './Button';
import { ImageClickable } from './ImageClickable';
export function Solution() {
  return <section className="py-8 md:py-10 px-3 md:px-4 bg-dark relative" data-id="element-257">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-rosa to-transparent" data-id="element-258"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-259">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4 uppercase" data-id="element-260">
          La Mujer que se Elige
        </h2>
        <p className="text-xl text-rosa font-bold mb-8" data-id="element-261">
          Es una guia para <strong data-id="element-262">sacarte de ese ciclo</strong>
        </p>

        <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-263">
          <div className="w-full md:w-1/2" data-id="element-264">
            <ImageClickable src="https://cdn.magicpatterns.com/uploads/9CdkZzZyE9koJr1ecmM6sp/COVERS_LA_MUJER_QUE_SE_ELIGE_(1080_x_1080_px).png" alt="La Mujer que se Elige" className="w-full rounded-2xl border-2 border-terracota/30 shadow-[0_0_30px_rgba(201,123,99,0.2)]" data-id="element-265" />
          </div>
          <div className="w-full md:w-1/2 text-left space-y-4" data-id="element-266">
            <p className="text-lg text-gray-200" data-id="element-267">
              Vas a aprender a{' '}
              <strong className="text-white" data-id="element-268">
                identificar y cambiar los patrones
              </strong>{' '}
              que siempre repites y te hacen{' '}
              <strong className="text-white" data-id="element-269">volver a lo mismo</strong>.
            </p>
            <div className="h-px w-12 bg-terracota" data-id="element-270"></div>
            <p className="text-lg text-white font-semibold" data-id="element-271">
              Para que <strong className="text-rosa" data-id="element-272">dejes de depender</strong>{' '}
              de alguien que aparece y desaparece y empieces a tener{' '}
              <strong className="text-rosa" data-id="element-273">
                control real sobre lo que sentís
              </strong>
              .
            </p>
          </div>
        </div>

        <Button data-id="element-274">QUIERO SALIR DE ESTE CICLO</Button>
      </div>
    </section>;
}